import { useTranslation } from 'react-i18next'
import { NestedLink, PreviousPage, ScreenLayout } from '../ScreenLayout'
import { ReactNode } from 'react'

interface SettingsPageProps {
  title: string
  rightOfTitle?: ReactNode
  children: ReactNode
  previousPages?: PreviousPage[]
  nestedLinks?: NestedLink[]
}

export const SettingsPage: React.FC<SettingsPageProps> = ({
  title,
  rightOfTitle,
  children,
  previousPages = [],
  nestedLinks = [],
}: SettingsPageProps) => {
  const { t } = useTranslation()

  if (previousPages[0]?.title !== t('settings_page.title')) {
    previousPages.unshift({
      path: '/settings',
      title: t('settings_page.title'),
    })
  }

  return (
    <ScreenLayout
      title={title}
      rightOfTitle={rightOfTitle}
      previousPages={previousPages}
      nestedLinks={nestedLinks}
    >
      {children}
    </ScreenLayout>
  )
}
